/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    import MapConfiguration = Wars.Domain.Model.Gis.MapConfiguration;

    export class MapConfigurationOverridesService extends services.DataService<Wars.Domain.Model.Gis.MapConfigurationOverride> {

        constructor(injectedBreeze: typeof breeze, $q: angular.IQService, private $http: angular.IHttpService) {
            super(injectedBreeze, $q);
        }

        public createMapConfigurationOverrides(): Wars.Domain.Model.Gis.MapConfigurationOverride {
            return this.createNewEntity<Wars.Domain.Model.Gis.MapConfigurationOverride>("MapConfigurationOverride");
        }

        public createIncludedMapFunction(): Wars.Domain.Model.Gis.IncludedMapFunction {
            return this.createNewEntity<Wars.Domain.Model.Gis.IncludedMapFunction>("IncludedMapFunction");
        }

        public createGisActionWorkflowOverride(): Wars.Domain.Model.Gis.GisActionWorkflowOverride {
            return this.createNewEntity<Wars.Domain.Model.Gis.GisActionWorkflowOverride>("GisActionWorkflowOverride");
        }

        public createQueryGridOverride(): Wars.Domain.Model.Gis.QueryGridOverride{
            return this.createNewEntity<Wars.Domain.Model.Gis.QueryGridOverride>("QueryGridOverride");
        }

        public createGisActionWorkflowGisFieldMap(): Wars.Domain.Model.Gis.GisActionWorkflowGisFieldMap {
            return this.createNewEntity<Wars.Domain.Model.Gis.GisActionWorkflowGisFieldMap>("GisActionWorkflowGisFieldMap");
        }

        public createGisWherePlaceHolderValue(): Wars.Domain.Model.Gis.GisWherePlaceHolderValue {
            return this.createNewEntity<Wars.Domain.Model.Gis.GisWherePlaceHolderValue>("GisWherePlaceHolderValue");
        }

        public getMapConfigurationOverrides(processConfigurationId: string): angular.
            IPromise<Wars.Domain.Model.Gis.MapConfigurationOverride[]> {
            const query = this.breezeModule.EntityQuery
                .from("MapConfigurationOverrides")
                .where('processConfiguration_id', '==', processConfigurationId)
                .expand('includedMapFunctions.placeHolderValues, gisActionWorkflowOverrides.fieldMappings,' +
                    ' queryGridConfigurationOverrides.placeHolderValues, '+
                    ' queryGridConfigurationOverrides.queryGridConfiguration.queryGridQueries.esriQueryConfiguration.wherePredicates, '+
                    ' queryGridConfigurationOverrides.queryGridConfiguration.queryGridQueries.gisDatastoreQueryConfiguration.wherePredicates, '+
                    ' gisActionWorkflowOverrides.gisActionWorkflowConfiguration.outputCollection.gisInputOutputs,' +
                    ' gisActionWorkflowOverrides.gisActionWorkflowConfiguration.gisActionBlocks.addFeaturesConfiguration.gisDatastore')
                .orderBy("name");

            return this.executeQuery(query);
        }
    }
}
warsApp.registerService('MapConfigurationOverridesService', ['breeze', '$q', '$http'])
